import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MonitorUp, Loader2, X } from 'lucide-react';
import { api } from '../../context/AuthContext';

export const CobrowseEinladenKnopf = ({ caseId, gross }) => {
  const nav = useNavigate();
  const [ziele, setZiele] = useState(null);
  const [busy, setBusy] = useState('');
  const [fehler, setFehler] = useState('');
  const oeffnen = async () => {
    setFehler('');
    try {
      const { data } = await api.get(`/cobrowse/akte/${caseId}/ziele`);
      if (data.length === 1 && data[0].konto) einladen(data[0]); else setZiele(data);
    } catch (e) { setFehler(e?.response?.data?.detail || 'Laden fehlgeschlagen'); setZiele([]); }
  };
  const einladen = async (z) => {
    setBusy(z.mandanten_nr);
    try {
      const { data } = await api.post('/cobrowse/einladen', { mandanten_nr: z.mandanten_nr, case_id: caseId.startsWith('general_') ? '' : caseId });
      nav('/kanzlei/cobrowsing', { state: { sitzung: data } });
    } catch (e) { setFehler(e?.response?.data?.detail || 'Einladung fehlgeschlagen'); setZiele((x) => x || []); } finally { setBusy(''); }
  };
  return (
    <span className="relative inline-flex">
      {gross ? (
        <button type="button" onClick={oeffnen} data-tipp="Mandanten zu einer Co-Browsing-Sitzung einladen – gemeinsam auf seinen Bildschirm schauen" data-testid="pf-cobrowse-einladen"
          className="shrink-0 whitespace-nowrap inline-flex items-center gap-1.5 h-9 px-3 rounded-lg text-[13px] font-semibold text-white bg-[#b8893d] hover:bg-[#9a702e] transition-colors">
          {busy && !ziele ? <Loader2 className="w-4 h-4 animate-spin" /> : <MonitorUp className="w-4 h-4" />}Co-Browsing
        </button>
      ) : (
      <button type="button" onClick={oeffnen} title="Mandanten zu Co-Browsing einladen" data-testid="thread-cobrowse-einladen"
        className="shrink-0 whitespace-nowrap inline-flex items-center gap-1 h-6 px-2 rounded-full border border-[#b8893d]/50 text-[10px] tracking-wider text-[#b8893d] hover:bg-[#b8893d] hover:text-white transition-colors">
        {busy && !ziele ? <Loader2 className="w-3 h-3 animate-spin" /> : <MonitorUp className="w-3 h-3" />} <span className="hidden sm:inline">CO-BROWSING</span>
      </button>
      )}
      {ziele && (
        <div className={`absolute z-50 top-10 ${gross ? "right-0" : "left-0"} w-72 bg-white rounded-xl shadow-2xl border border-gray-100 p-2`} data-testid="thread-cobrowse-ziele">
          <div className="flex items-center px-2 py-1 text-[10px] tracking-[0.2em] uppercase text-[#b8893d]">Wen einladen?
            <button type="button" onClick={() => setZiele(null)} className="ml-auto text-gray-400 hover:text-[#1B3A5C]" aria-label="Schließen"><X className="w-3.5 h-3.5" /></button></div>
          {ziele.map((z) => (
            <button key={z.mandanten_nr} type="button" disabled={!z.konto || !!busy} onClick={() => einladen(z)} data-testid={`thread-cobrowse-ziel-${z.mandanten_nr}`}
              className="w-full text-left px-2 py-2 rounded-lg hover:bg-[#f5f8fa] disabled:opacity-50 disabled:hover:bg-transparent">
              <span className="block text-sm text-[#1B3A5C]">{z.name} <span className="text-[10px] text-[#b8893d]">{z.rolle}</span></span>
              <span className="block text-[11px] text-gray-500">{z.konto ? z.email : 'Kein Portalkonto – bitte per Code starten'}</span>
            </button>
          ))}
          {fehler && <p className="px-2 py-1 text-[11px] text-rose-700" data-testid="thread-cobrowse-fehler">{fehler}</p>}
        </div>
      )}
    </span>
  );
};

export default CobrowseEinladenKnopf;
